// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    access_levels: 'Toegangsniveaus',
    activityList: 'Activiteitencentrum',
    addlicenses: 'Licenties toevoegen',
    approvals: 'Goedkeuringsaanvragen',
    archive: 'Archief',
    billingReport: 'Factureringsrapport',
    builder: 'Bouwer',
    commonReports: 'Algemene rapporten',
    companySettings: 'Bedrijfsinstellingen',
    customers: 'Klanten',
    customfields: 'Aangepaste velden',
    dashboard: 'Dashboard',
    days_left: '1#Proefperiode eindigt over {0} dag#Proefperiode eindigt over {0} dagen',
    featurelabs: 'Functielabs',
    forms: 'Aangepaste formulieren',
    generalOptions: 'Accountinstellingen',
    guestPortal: 'Gastenportal',
    integrations: 'Automatiseringen',
    invoices: 'Facturen',
    jobroles: 'Functierollen',
    logout: 'Uitloggen',
    mobile_apps: 'Mobiele apps',
    myassignments: 'Mijn opdrachten',
    myoptions: 'Mijn instellingen',
    mySettingsNotifications: 'Meldingen',
    mySettingsOptions: 'Geavanceerde instellingen',
    mySettingsProfile: 'Profiel',
    myvacations: 'Mijn vakanties',
    notificationCenter: 'Meldingen',
    notifications: 'Meldingsinstellingen',
    payrollReport: 'Salarisrapport',
    portfolios: 'Portefeuilles',
    powerbi: 'BI-dashboards',
    presetsHideViewTooltip: 'Verberg weergave',
    presetsListTitle: 'Opgeslagen weergaven',
    projectCentricView: 'Projectgerichte weergave',
    ratecards: 'Tariefkaarten',
    recommend_us: 'Verwijzingsprogramma',
    reportgenerator: 'Aangepast rapport',
    reports: 'Rapporten',
    resourcesPage: 'Middelen',
    roles: 'Rollen',
    search: 'Zoeken',
    sharedProjectPlans: 'Gedeelde projectmomentopnamen',
    space: 'Ruimte-instellingen',
    spaces: 'Ruimtes',
    summaryReport: 'Samenvatting van tijdregistratierapporten',
    support_center: 'Ondersteuningscentrum',
    support_chat: 'Ondersteuningschat',
    systemLists: 'Systeemlijsten',
    timelogs: 'Tijdregistraties',
    updateLicense: 'Licentie bijwerken',
    upgrade_now: 'Nu upgraden',
    users: 'Gebruikers',
    vacationsreport: 'Vakanties',
    whatif: 'Simulatie van belasting van middelen',
    workflows: 'Workflows',
};
